module.exports = __webpack_public_path__ + "img/close_xl.a6812e52.svg";